import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/html5': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M0 32h384l-34.9 395.8-157.6 52.2-156.6-52.2zM308.2 159.9l4.4-47.7h-241.1l12.8 145.6h166.9l-6 62.2-53.7 14.5-53.5-14.5-3.5-38.1h-47.7l6 75.8 98.7 27.3h1.1v-0.3l97.9-27 13.6-148.4h-175.6l-4.1-49.4h183.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/html5.js
// module id = 883
// module chunks = 0